import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { UrAddPage } from '../ur-add/ur-add'
import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-list',
  templateUrl: 'list.html'
})
export class ListPage {
  item: any;
  items: any;
  error: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http
    ) {

    this.item = navParams.get('item');

    console.log(this.item);

    if (!navParams.get('item')) {

      let loadingPopup = this.loadingCtrl.create({
        content: ''
      });

      loadingPopup.present();

      this.http.get(this.params.apiURL + '?act=news')
        .timeout(20000)
        .map(res => res.json())
        .subscribe(
          data => {
            //setTimeout(() => {
              console.log(data);
              this.items = data;
              this.error = "0";

              //console.log('ITEMS: ' + this.items.id);

              if (navParams.get('id_show')) {
                let that = this;
                this.items.forEach(function(item, i) {
                  if (item.id==navParams.get('id_show')) that.item = item;
                });                
              }

              loadingPopup.dismiss();

            //}, 1000);

          },

          err => {
            loadingPopup.dismiss();
            this.error = "1";
          }

        );

    }


  }

  itemShow(item) {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(ListPage, {
      item: item
    });
  }

  addQ() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(UrAddPage);
  }

  ionViewWillEnter() {
    this.params.stat('news');    
  }   
}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts